import React from "react";
import { ActionTimestamp } from "../../state/action";
import { IReducer } from "../../state/reducer";
import { BrickInfoTotal } from "../../state/BrickInfoTotal/BrickInfoTotal";
import "./ActivityFeed.css";

// Aggregate timestamps by id within the 30-second window
function aggregateTimestamps(
  timestamps: ActionTimestamp[],
): Map<string, number> {
  const aggregatedMap = new Map<string, number>();

  timestamps.forEach((timestamp) => {
    const existingAmount = aggregatedMap.get(timestamp.id) || 0;
    aggregatedMap.set(timestamp.id, existingAmount + timestamp.amount);
  });

  return aggregatedMap;
}

const ActivityFeed: React.FC<IReducer> = ({ state }) => {
  const aggregatedTimestamps = aggregateTimestamps(state.actionTimestamps);

  // return state.actions.get("brickpack_minifig_utensils_part_one")?.visible ? (
  return false ? (
    <div className="moduleContainer">
      <div className="inventoryHeader">
        <div className="headerContent">
          <div className="inventoryHeaderTitle">Activity Feed</div>
          <div className="activitySubheader">Last 30 seconds</div>
        </div>
      </div>
      <div className="activityFeed">
        {Array.from(aggregatedTimestamps)
          .sort(([idA], [idB]) => idA.localeCompare(idB))
          .map(([id, amount]) => (
            <div key={id} className="activityEntry">
              {BrickInfoTotal.get(id)?.name}: {amount}
            </div>
          ))}
      </div>
    </div>
  ) : null;
};

export default ActivityFeed;
